// routes/HomeRoutes.tsx
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setUTM } from '@/store/slices/utm/utmSlice';

function CaptureAndRedirect() {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (location.search) {
      const p = new URLSearchParams(location.search);
      const hasAny =
        p.has('utm_source') ||
        p.has('utm_medium') ||
        p.has('utm_campaign') ||
        p.has('utm_content') ||
        p.has('utm_term');
      if (hasAny) {
        dispatch(
          setUTM({
            utm_source: p.get('utm_source'),
            utm_medium: p.get('utm_medium'),
            utm_campaign: p.get('utm_campaign'),
            utm_content: p.get('utm_content'),
            utm_term: p.get('utm_term'),
          }),
        );
      }
    }
  }, [dispatch, location.search]);

  return (
    <Navigate to={`/onboarding/mortgage-goal${location.search}`} replace />
  );
}

export const HomeRoutes = () => (
  <Routes>
    <Route path="/" element={<CaptureAndRedirect />} />
  </Routes>
);
